import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const AdminRoute = () => {
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));

  if (userInfo && userInfo.mustChangePassword) {
    return <Navigate to='/profile' replace />;
  }

  return userInfo && userInfo.role === 'ADMIN' ? <Outlet /> : <Navigate to='/login' replace />;
};

export default AdminRoute;
